import SectionHeader from "@/components/SectionHeader";
import { Reveal } from "@/components/Reveal";
import { getIcon } from "@/components/iconMap";

export const Strengths = ({ strengths = [] }) => {
  return (
    <section data-testid="strengths-section" className="py-24 lg:py-32 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeader
          index="02"
          eyebrow="What I'm awesome at"
          title="Clarity, brought to complex problems"
          description="I bring clarity to complex problems through user-centred research, seamless collaboration, and hands-on delivery — making sure great ideas become real, impactful products."
        />

        <div className="mt-16 grid sm:grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {strengths.map((s, i) => {
            const Icon = getIcon(s.icon);
            return (
              <Reveal key={s.title} delay={i * 0.07}>
                <div
                  data-testid={`strength-card-${i}`}
                  className="h-full bg-ink p-8 lg:p-10 hover:bg-surface transition-colors duration-300"
                >
                  <div className="flex items-center justify-center h-12 w-12 rounded-full border border-white/15 mb-7">
                    <Icon size={20} className="text-cream" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-heading text-xl tracking-tight text-cream mb-3">{s.title}</h3>
                  <p className="text-ash leading-relaxed">{s.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Strengths;
